import { Component, OnInit, Input } from '@angular/core';

import { InjectionPressureDataRecord } from '../_models/injection-pressure-data-record';
import { InjectionPressureDataBatch } from '../_models/injection-pressure-data-batch';

@Component({
  selector: 'app-bhp-presubmit-data-table',
  templateUrl: './bhp-presubmit-data-table.component.html',
  styleUrls: ['./bhp-presubmit-data-table.component.css']
})
export class BhpPresubmitDataTableComponent implements OnInit {

  public displayedColumns = [
    "MeasurementDate",
    "ShutinBHPQuarterlyCalc",
    "ShutinBHPQuarterlyMeas",
    "ShutinBHPDaily",
    "TvdDepBHPSensor",
    "MeaDayInjLiqDens",
    "AveDayMeasBhp",
    "MaxDayMeasBhp",
    "AveDayEstBhp",
    "MaxDayEstBhp",
    "ShutinTimeForStaticPress"
  ];

  @Input()
  public bhpBatch: InjectionPressureDataBatch = null;

  constructor() { }

  ngOnInit(): void {
  }

}
